module.exports = __webpack_public_path__ + "c72fbfd20b752942106577cf8f618ed9.svg";